export enum FilterType {
	MY = "my",
	SPECIFIC = "specific",
	UNASSIGNED = "unassigned",
	ALL = "all",
}
